import { apiPost } from '@/services/api/client';

export type StudentData = {
  student_1?: string;
  student_2?: string;
  student_3?: string;
  student_1_time?: string;
  student_2_time?: string;
  student_3_time?: string;
};

export async function submitShift(args: {
  userId: string;
  shiftId: string;
  studentData: StudentData;
}): Promise<{ response?: string } & Record<string, unknown>> {
  return apiPost(
    'submitShift',
    {
      userId: args.userId,
      shiftId: args.shiftId,
      studentData: args.studentData,
    },
    { timeoutMs: 60_000 },
  );
}
